<div class="summary-holder">
  <div [class]="{ hidden: !signingInProgress() }" class="progress">
    <p>Signering pågår...</p>
  </div>

  <!-- BankID component - hidden but kept in DOM -->
  <div [class]="{ hidden: !signingHidden() || signingInProgress() }">
    <spb-bankid
      mode="sign"
      [domain]="domain"
      [startUrl]="requestApi"
      [bankIdUrl]="authServiceUrl"
      [userRef]="accountApplication.id"
      [disabled]="!accountApplication.id"
      [hideButton]="true"
      (currentMode)="cancelSigning($event)"
      (accessToken)="submitSignature($event)"
    />
  </div>

  <!-- Main content - hidden during signing -->
  <div [class]="{ hidden: signingHidden() || signingInProgress() }">
    <h1>Godkännande av information</h1>
    <p>Du har nu fyllt i alla frågor.</p>

    <div [style.margin-top.rem]="2.5">

      <spb-application-summary
        title="Sammanfattning av ansökan"
        text="Kontrollera att alla uppgifter stämmer innan du går vidare. Om någon uppgift inte är korrekt kan du gå tillbaka i ansökan och ändra den."
        [sections]="summarySections()"
      />
    </div>

    <div class="navigation-buttons small-screen"
         [style.gap.rem]="1">

      <button
        matButton="outlined"
        matStepperPrevious>
        Föregående
      </button>

      <button
        matButton="filled"
        [disabled]="!stepperTrigger()"
        (click)="startSigning()">
        Godkänn med BankID
      </button>
    </div>

    @if (errorMessage) {
      <div [style.text-align]="'center'">
        <mat-error>{{ errorMessage }}</mat-error>
      </div>
    }
  </div>
</div>